import { useCallback, useEffect, useState } from 'react'

export type UseBaselinePreviewResult = {
  previewBaseline: boolean
  startPreview: () => void
  endPreview: () => void
}

const useBaselinePreview = (enabled: boolean): UseBaselinePreviewResult => {
  const [pressed, setPressed] = useState(false)

  const startPreview = useCallback(() => {
    if (enabled) setPressed(true)
  }, [enabled])

  const endPreview = useCallback(() => {
    setPressed(false)
  }, [])

  // If preview gets disabled mid-press (e.g., user resets adjustments
  // while still holding the compare button), exit preview immediately.
  useEffect(() => {
    if (!enabled && pressed) setPressed(false)
  }, [enabled, pressed])

  return {
    previewBaseline: pressed && enabled,
    startPreview,
    endPreview,
  }
}

export default useBaselinePreview
